import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headertest',
  templateUrl: './headertest.component.html',
  styleUrls: ['./headertest.component.css']
})
export class HeadertestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
